export const FIND_PROCESS_STATEMENT_RESULTS_REQUEST = 'FIND_PROCESS_STATEMENT_RESULTS_REQUEST';

export const findProcessStatementResultsRequest = ( id ) => ({
    type: FIND_PROCESS_STATEMENT_RESULTS_REQUEST,
    payload: { id }
});
